import { lazy } from 'react';
import Loadable from './Loadable';
import { GuestGuard } from 'components/auth';
import { IS_GUEST_VIEW } from '../app.config';

// AUTHENTICATION RELATED PAGES
const Login = Loadable(lazy(() => import('pages/sessions/login')));
// const Register = Loadable(lazy(() => import('pages/sessions/register')));
// const VerifyCode = Loadable(lazy(() => import('pages/sessions/verify-code')));
const ForgetPassword = Loadable(
  lazy(() => import('pages/sessions/forget-password'))
);
const ForgotPasswordChangePasswrord = Loadable(
  lazy(() => import('pages/sessions/forget-password-change-password'))
);
const SuccessChangePassword = Loadable(
  lazy(() => import('pages/sessions/success-change-password-page'))
);
const RegistrationCompany = Loadable(
  lazy(() => import('pages/sessions/registrationCompany'))
);

const SignupPage = Loadable(lazy(() => import('pages/sessions/signupPage')));
const Otp = Loadable(lazy(() => import('pages/sessions/otp')));
const GuestLogin = Loadable(
  lazy(() => import('pages/sessions/loginGuestPage'))
);

const EmailVerification = Loadable(
  lazy(() => import('pages/sessions/emailVerification'))
);

const isGuest = IS_GUEST_VIEW;

export const AuthRoutes = [
  // AUTHENTICATION PAGES ROUTES
  {
    element: <GuestGuard />,
    children: [
      {
        path: 'login',
        element: isGuest ? <GuestLogin /> : <Login />
      },
      {
        path: 'company-registration',
        element: <RegistrationCompany />
      },
      // {
      //   path: 'register',
      //   element: <Register />
      // },
      {
        path: 'forget-password',
        element: <ForgetPassword />
      },
      {
        path: 'forgot-password',
        element: <ForgotPasswordChangePasswrord />
      },
      {
        path: 'set-password',
        element: <ForgotPasswordChangePasswrord />
      },
      {
        path: 'confirm-registration',
        element: <ForgotPasswordChangePasswrord />
      },
      {
        path: 'success-change-password',
        element: <SuccessChangePassword />
      },
      {
        path: 'sign-up/:formUrl',
        element: <SignupPage />
      },
      {
        path: 'otp/:email',
        element: <Otp />
      },
      {
        path: 'email-verification',
        element: <EmailVerification />
      }
    ]
  }
];
